import { Button } from '@abyss/web/ui/Button';
import { Layout } from '@abyss/web/ui/Layout';
import { V2ModalDialog } from '@abyss/web/ui/ModalDialog';
import { Text } from '@abyss/web/ui/Text';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const IDLE_MILLIS = 25 * 60 * 1000;
const END_SESSION_MILLIS = 5 * 60 * 1000;
const ACTIONS = ['mousedown', 'focus', 'keydown'];

export const GuestIFPTimeoutModal = () => {
  const [isInactive, setIsInactive] = useState<boolean>(false);
  const [sessionActive, setSessionActive] = useState<boolean>(true);

  const { t } = useTranslation();

  useEffect(() => {
    const addEventListeners = (listener) => {
      ACTIONS.forEach((eventName) => {
        window.addEventListener(eventName, listener);
      });
    };

    const removeEventListeners = (listener) => {
      ACTIONS.forEach((eventName) => {
        window.removeEventListener(eventName, listener);
      });
    };
    const idleTimeout = () =>
      setTimeout(() => {
        setIsInactive(true);
        setSessionActive(true);
      }, IDLE_MILLIS);

    const logoutTimeout = () =>
      setTimeout(() => {
        setSessionActive(false);
      }, END_SESSION_MILLIS);

    let timeout = isInactive ? logoutTimeout() : idleTimeout();

    const listener = () => {
      if (!isInactive) {
        clearTimeout(timeout);
        timeout = idleTimeout();
      }
    };

    addEventListeners(listener);

    return () => {
      removeEventListeners(listener);
      clearTimeout(timeout);
    };
  }, [isInactive]);

  const handleContinue = () => {
    setIsInactive(false);
  };

  const handleEndSession = () => {
    setSessionActive(false);
  };
  if (!isInactive) {
    return null;
  }
  return (
    <V2ModalDialog
      closeOnClickOutside={false}
      css={{
        'abyss-modal-base-header-container': {
          padding: '16px',
        },
      }}
      footer={
        sessionActive && (
          <Layout.Group alignLayout="right" style={{ gap: 8 }}>
            <Button
              data-auto-testid="timeout-modal-end-session"
              data-testid="timeout-modal-end-session"
              onClick={handleEndSession}
              variant="outline"
            >
              {t('INACTIVITY_MODAL.END_SESSION')}
            </Button>
            <Button
              data-auto-testid="timeout-modal-continue-session"
              data-testid="timeout-modal-continue-session"
              onClick={handleContinue}
            >
              {t('INACTIVITY_MODAL.CONTINUE')}
            </Button>
          </Layout.Group>
        )
      }
      header={t('INACTIVITY_MODAL.TITLE')}
      hideClose={!sessionActive}
      isOpen
      onClose={handleContinue}
    >
      <Text>
        {sessionActive
          ? t('INACTIVITY_MODAL.IFPEARLYPAY_BODY_LINE_1')
          : t('INACTIVITY_MODAL.IFPEARLYPAY_BODY_LINE_3')}
      </Text>
      <Text>
        {sessionActive
          ? t('INACTIVITY_MODAL.IFPEARLYPAY_BODY_LINE_2')
          : t('INACTIVITY_MODAL.IFPEARLYPAY_BODY_LINE_4')}
      </Text>
    </V2ModalDialog>
  );
};
